export default __webpack_public_path__ + "static/1_30-72cbf989a70ca551c99aee0340aad029.png";